// client/src/coms/views/watch_together_parts/WatchTogetherGate.js
import React from 'react';

export default function WatchTogetherGate() {
  return (
    <div
      className="coms-view"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        height: '100%',
        padding: 18,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.10 * var(--vx-ov, 1)))',
          background: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.03 * var(--vx-ov, 1)))',
          borderRadius: 16,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: 24,
            background: 'linear-gradient(180deg, rgba(var(--vxs-2-rgb, 20,20,24), 0.72), rgba(var(--vxs-0-rgb, 10,10,14), 0.90))',
          }}
        >
          <div>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: '-0.02em' }}>Watch Together</div>
            <div style={{ marginTop: 10, fontSize: 14, opacity: 0.82, maxWidth: 480, lineHeight: 1.5 }}>
              Join a voice channel to use Watch Together.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}